let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kPTH8")).then(() => parcelRequire('b47ZY'));